module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "edit-user fill-height",
    attrs: {
      "fluid": ""
    }
  }, [_c('Dialog', {
    attrs: {
      "dialog": _vm.deleteUserDialog.show,
      "cardText": _vm.deleteUserDialog.cardText,
      "mainBtnText": _vm.deleteUserDialog.mainBtnText,
      "secondaryBtnText": _vm.deleteUserDialog.secondaryBtnText,
      "alertColor": true
    },
    on: {
      "update:dialog": function($event) {
        return _vm.$set(_vm.deleteUserDialog, "show", $event)
      },
      "mainBtnCallback": _vm.deleteUser
    }
  }), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbar.timeout,
      "top": "",
      "color": _vm.snackbar.color,
      "rounded": "",
      "centered": ""
    },
    model: {
      value: (_vm.snackbar.show),
      callback: function($$v) {
        _vm.$set(_vm.snackbar, "show", $$v)
      },
      expression: "snackbar.show"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.snackbar.text) + "\n  ")]), _vm._v(" "), _c('v-layout', {
    staticClass: "div-center-horizontally"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-container', {
    staticClass: "medium-div"
  }, [_c('v-layout', {
    staticClass: "header-row",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "div-center-vertically"
  }, [(!_vm.permissionsByDeviceDialog) ? [_c('p', {
    staticClass: "org-name"
  }, [_vm._v(_vm._s(_vm.userName))])] : [_c('p', {
    staticClass: "org-name"
  }, [_c('a', {
    staticClass: "org-name-clickable",
    on: {
      "click": function($event) {
        _vm.permissionsByDeviceDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.userName))]), _vm._v(" / " + _vm._s(_vm.$t('EditUser.permissions')))])]], 2), _vm._v(" "), _c('v-flex', {
    staticClass: "card-actions div-center-vertically div-right-horizontally"
  }, [_c('p', {
    staticClass: "user-register-text"
  }, [_vm._v(_vm._s(_vm.$t('EditUser.userDetail')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "close-icon",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeCard
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "#000000"
    }
  }, [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "divider-row",
    attrs: {
      "row": ""
    }
  }, [_c('v-divider', {
    staticClass: "divider"
  })], 1), _vm._v(" "), (_vm.permissionsByDeviceDialog) ? _c('v-layout', {
    staticClass: "user-content-row",
    attrs: {
      "row": ""
    }
  }, [_c('PermissionsByDevice', {
    attrs: {
      "userData": _vm.userData,
      "permissionsByDeviceDialog": _vm.permissionsByDeviceDialog,
      "devicesPermissionsProp": _vm.devicesPermissions
    },
    on: {
      "update:userData": function($event) {
        _vm.userData = $event
      },
      "update:user-data": function($event) {
        _vm.userData = $event
      },
      "update:permissionsByDeviceDialog": function($event) {
        _vm.permissionsByDeviceDialog = $event
      },
      "update:permissions-by-device-dialog": function($event) {
        _vm.permissionsByDeviceDialog = $event
      },
      "update:devicesPermissionsProp": function($event) {
        _vm.devicesPermissions = $event
      },
      "update:devices-permissions-prop": function($event) {
        _vm.devicesPermissions = $event
      }
    }
  })], 1) : _c('v-layout', {
    class: _vm.display === 'xs' ? 'user-content-row-mobile' : 'user-content-row-desktop',
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "edit-user-div custom-scroll-bar",
    class: _vm.display === 'xs' ? 'edit-user-div-mobile' : 'edit-user-div-desktop',
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-col', [_c('v-form', {
    ref: "editUserForm"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "profile-pic-col",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "load-img-container"
  }, [_c('div', {
    staticClass: "load-img-btn-div"
  }, [_c('v-btn', {
    staticClass: "load-img-btn",
    attrs: {
      "fab": "",
      "small": ""
    },
    on: {
      "click": _vm.handleFileImport
    }
  }, [_c('v-icon', [_vm._v("\n                            photo_camera\n                          ")])], 1)], 1), _vm._v(" "), _c('input', {
    ref: "uploader",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "load-img-div"
  }, [_c('v-img', {
    staticClass: "profile-pic",
    attrs: {
      "id": "profile-pic",
      "width": "100%",
      "height": "100%",
      "src": _vm.profilePicSrc
    }
  })], 1)])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pt-6",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('EditUser.name')) + " *"),
      "title": ((_vm.$t('EditUser.name')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "requiredRules": "",
      "rules": _vm.$ponceConfig.requiredRules,
      "required": "",
      "maxlength": "50",
      "hide-details": ""
    },
    on: {
      "blur": _vm.parseNames
    },
    model: {
      value: (_vm.userData.name),
      callback: function($$v) {
        _vm.$set(_vm.userData, "name", $$v)
      },
      expression: "userData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pt-6",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('EditUser.lastName')) + " *"),
      "title": ((_vm.$t('EditUser.lastName')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "requiredRules": "",
      "rules": _vm.$ponceConfig.requiredRules,
      "required": "",
      "maxlength": "50",
      "hide-details": ""
    },
    on: {
      "blur": _vm.parseNames
    },
    model: {
      value: (_vm.userData.lastName),
      callback: function($$v) {
        _vm.$set(_vm.userData, "lastName", $$v)
      },
      expression: "userData.lastName"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pt-6",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.prevEmail) ? _c('v-text-field', {
    attrs: {
      "label": ((_vm.$t('EditUser.email')) + " *"),
      "title": ((_vm.$t('EditUser.email')) + " *"),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.$ponceConfig.emailRules,
      "required": "",
      "maxlength": "254",
      "hide-details": ""
    },
    model: {
      value: (_vm.userData.email),
      callback: function($$v) {
        _vm.$set(_vm.userData, "email", $$v)
      },
      expression: "userData.email"
    }
  }) : _c('div', {
    staticClass: "text-right"
  }, [_c('v-textarea', {
    staticClass: "no-account-label",
    attrs: {
      "label": ((_vm.$t('EditUser.email')) + " *"),
      "value": _vm.$t('EditUser.noAccountUser'),
      "title": _vm.$t('EditUser.noAccountUser'),
      "outlined": "",
      "background-color": "#FFF",
      "color": "#ffcc00",
      "disabled": "",
      "hide-details": "",
      "auto-grow": "",
      "rows": "1",
      "row-height": "15"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "text-none px-3",
    attrs: {
      "loading": _vm.resendLoading,
      "medium": "",
      "color": "#0098E1",
      "dark": ""
    },
    on: {
      "click": _vm.resendUserInvitationHandler
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('EditUser.resendInvitation')) + "\n                        "), _c('v-icon', {
    staticClass: "mr-0",
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("\n                          forward_to_inbox\n                        ")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pt-6",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.roles,
      "item-value": "value",
      "item-text": function (item) { return _vm.$t(("Roles." + (item.value))); },
      "label": ((_vm.$t('EditUser.role')) + " *"),
      "title": ((_vm.$t('EditUser.role')) + " *"),
      "menu-props": {
        bottom: true,
        offsetY: true
      },
      "outlined": "",
      "background-color": "#FFF",
      "color": "#0098E1",
      "rules": _vm.$ponceConfig.requiredRules,
      "required": "",
      "hide-details": "",
      "disabled": _vm.userData.role === _vm.USER_ROLES.OWNER && !_vm.$store.getters.user.isAdmin
    },
    on: {
      "change": _vm.setUserImg
    },
    model: {
      value: (_vm.userData.role),
      callback: function($$v) {
        _vm.$set(_vm.userData, "role", $$v)
      },
      expression: "userData.role"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "section-text text-left pt-2"
  }, [_vm._v(_vm._s(_vm.$t('GeneralPermissions.permissions')))])])], 1), _vm._v(" "), _vm._l((Object.keys(_vm.permissions)), function(perm) {
    return _c('v-row', {
      key: ("switch_" + perm),
      staticClass: "permissions-elements flex-nowrap",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-switch', {
      attrs: {
        "inset": "",
        "color": "#00D166",
        "disabled": _vm.userData.permissionsCustomized
      },
      model: {
        value: (_vm.permissions[perm]),
        callback: function($$v) {
          _vm.$set(_vm.permissions, perm, $$v)
        },
        expression: "permissions[perm]"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "mb-0 text-start align-self-center"
    }, [_vm._v(_vm._s(_vm.$t(("UsersPermissions." + perm))))])], 1)
  }), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "section-text text-left pt-2"
  }, [_vm._v(_vm._s(_vm.$t('GeneralPermissions.channels')))])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "permissions-elements flex-nowrap mt-0"
  }, [_c('v-switch', {
    attrs: {
      "inset": "",
      "color": "#00D166"
    },
    on: {
      "click": function($event) {
        return _vm.changeChannel('push')
      }
    },
    model: {
      value: (_vm.pushChannel),
      callback: function($$v) {
        _vm.pushChannel = $$v
      },
      expression: "pushChannel"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mb-0 text-start align-self-center"
  }, [_vm._v(_vm._s(_vm.$t('GeneralPermissions.push')))])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "permissions-elements flex-nowrap mt-0"
  }, [_c('v-switch', {
    attrs: {
      "inset": "",
      "color": "#00D166"
    },
    on: {
      "click": function($event) {
        return _vm.changeChannel('whatsapp')
      }
    },
    model: {
      value: (_vm.whatsappChannel),
      callback: function($$v) {
        _vm.whatsappChannel = $$v
      },
      expression: "whatsappChannel"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mb-0 text-start align-self-center"
  }, [_vm._v(_vm._s(_vm.$t('GeneralPermissions.whatsapp')))])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "permissions-elements flex-nowrap mt-0"
  }, [_c('v-switch', {
    attrs: {
      "inset": "",
      "color": "#00D166"
    },
    on: {
      "click": function($event) {
        return _vm.changeChannel('sms')
      }
    },
    model: {
      value: (_vm.smsChannel),
      callback: function($$v) {
        _vm.smsChannel = $$v
      },
      expression: "smsChannel"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "mb-0 text-start align-self-center"
  }, [_vm._v(_vm._s(_vm.$t('GeneralPermissions.sms')))])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pt-3 pb-5",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('VuePhoneNumberInput', {
    attrs: {
      "color": "#0098E1",
      "size": "md",
      "default-country-code": _vm.defaultCountryCode(),
      "translations": _vm.phoneInputTranslations
    },
    on: {
      "update": _vm.setPhoneNumber
    },
    model: {
      value: (_vm.phoneNumberInput),
      callback: function($$v) {
        _vm.phoneNumberInput = $$v
      },
      expression: "phoneNumberInput"
    }
  })], 1)], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "edit-permissions-div",
    class: _vm.display === 'xs' ? 'edit-permissions-div-mobile' : 'edit-permissions-div-desktop',
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('v-col', {
    staticClass: "full-height pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticStyle: {
      "justify-content": "right"
    },
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-btn', {
    staticClass: "text-none text-body-2 font-weight-bold my-0 mx-0",
    attrs: {
      "text": "",
      "color": "#0098E1"
    },
    on: {
      "click": _vm.openPermissionsByDevice
    }
  }, [_vm._v(_vm._s(_vm.$t('EditUser.seePermisions')))])], 1), _vm._v(" "), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('p', {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(_vm.$t('EditUser.assignedDevices')))])]), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-row', {
    staticStyle: {
      "justify-content": "end"
    },
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-switch', {
    staticClass: "text-end mt-0",
    attrs: {
      "inset": "",
      "color": "#00D166",
      "label": _vm.$t('EditUser.selectAll')
    },
    model: {
      value: (_vm.selectAll),
      callback: function($$v) {
        _vm.selectAll = $$v
      },
      expression: "selectAll"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "assigned-devices-div",
    class: _vm.display === 'xs' ? 'assigned-devices-div-mobile' : 'assigned-devices-div-desktop',
    attrs: {
      "no-gutters": ""
    }
  }, _vm._l((_vm.assignedDevices), function(device) {
    return _c('v-flex', {
      key: device.name,
      staticClass: "px-2 fit-content",
      attrs: {
        "xs6": "",
        "sm4": ""
      }
    }, [_c('v-row', {
      staticClass: "device-elements flex-nowrap"
    }, [_c('v-switch', {
      attrs: {
        "input-value": device.isAssigned,
        "inset": "",
        "color": "#00D166"
      },
      on: {
        "change": function($event) {
          return _vm.updateDeviceAssignment(device, $event)
        }
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "mb-0 text-start align-self-center"
    }, [_vm._v(_vm._s(device.campaign.entityName))])], 1)], 1)
  }), 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    staticClass: "d-flex flex-column align-center"
  }, [_c('v-btn', {
    staticClass: "text-none text-h6 font-weight-light",
    attrs: {
      "medium": "",
      "disabled": _vm.loadingSave,
      "loading": _vm.loadingDelete,
      "color": "#F93A2F",
      "dark": ""
    },
    on: {
      "click": _vm.deleteUserBtnHandler
    }
  }, [_vm._v(_vm._s(_vm.$t('EditUser.deleteUser')))])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "d-flex flex-column align-center"
  }, [_c('v-btn', {
    staticClass: "text-none text-h6 font-weight-light",
    attrs: {
      "disabled": _vm.loadingDelete,
      "loading": _vm.loadingSave,
      "medium": "",
      "color": "#0098E1",
      "dark": ""
    },
    on: {
      "click": _vm.saverUserData
    }
  }, [_vm._v(_vm._s(_vm.$t('EditUser.save')))])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-797c6124","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Additions/EditUser.vue
// module id = 1739
// module chunks = 0